import { useMutation, useQueries, useQuery, useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import { styled } from "@mui/material";
import * as Yup from "yup";
import { Field, FormikProvider, FormikValues, useFormik } from "formik";
import Button from "../../../../customs/Button";
import Input from "../../../../customs/FormInput";
import Select from "../../../../customs/SelectInput";
import CustomTextArea from "../../../../customs/textarea";
import apiCall from "../../../../utils/apiCall";
import { NotificationContext } from "../../../../providers/notification";
import apiCallFormData from "../../../../utils/apiFormDataCall";
import { reOrderFetchedData } from "../../../../hooks/FetchData";




interface CreateScorePayload {
  //Id: number;
  RouteId: number;
  GradeLevel: string;
  Score: number;
  //ActiveStatus: boolean;
}
// interface ScoreTypeData{
//     Name: number;
//     ScoreTypeId: string;
// }


    interface RouteTypeData{
        RouteId: number;
        RouteName: string;
    }

interface ScoreTypeData {
  ScoreTypeId: number;
  RouteId: number;
  Name: string;
}

interface ComponentProps {
    handleClose: () => void;
}



const CreateScoreContent: React.FC<ComponentProps> = ({ handleClose }) => {
    const queryClient = useQueryClient();
    const { showNotification } = useContext(NotificationContext);


    const GetAllRoute = async (): Promise<any> => {
        return await apiCall().get(`Routes/GetAllRoute`);
      }
    
      const [getAllRouteQuery] = useQueries({queries: [
          {queryKey: ['get-allroutes'], queryFn: GetAllRoute, refetchOnWindowFocus: false, retry :1},
      ]}, );
        
    const createscore = async (payload: FormData) => {
        return await apiCallFormData().post(
        '/Applicant/CreateOrgAttainment',
        payload
        );
    };

    const createScoreMutation = useMutation(
        ["createscore"],
        createscore,
        { retry: 0 }
    );

    const createScoreHandler = async (values: FormikValues, resetForm: () => void) => {     
        

        const createScorePayload = new FormData()
        createScorePayload.append('RouteId', values.routeId)
        createScorePayload.append('GradeLevel', values.gradeLevel)
        createScorePayload.append('Score', values.score)

        try {
        await createScoreMutation.mutateAsync(createScorePayload, {
            onSuccess: () => {    
                showNotification({
                    message: 'Score created successful',
                    type: 'success',
                });
                queryClient.refetchQueries(["get-AllOrganAtt"]);
                handleClose();
            },
        });
        
        } catch (error: any) {
        showNotification({
            message: error?.response?.data?.Message || error?.message,
            type: "error",
        });
        }
    };

    const validationSchema = Yup.object().shape({
        routeId: Yup.number().typeError('Only numbers are allowed').required('Route Name is required'),
        gradeLevel:Yup.string().required('Grade Level is required'),
        score: Yup.number().typeError('Only numbers are allowed').required('Score is required'),
    })

    const formik = useFormik<FormikValues>({
        initialValues: {
            routeId: '',
            gradeLevel: '',
            score: '',
        },
        onSubmit: (values, { resetForm }) => {
            createScoreHandler(values, resetForm);
        },
        validationSchema,
    });

    const RouteTypeOption =
    getAllRouteQuery &&
    getAllRouteQuery?.data?.data?.Data?.length > 0 ? (
      reOrderFetchedData(getAllRouteQuery?.data?.data?.Data).map((route : RouteTypeData ) => (
            <option value={route?.RouteId} key = {route?.RouteId} >
                {route?.RouteName}
            </option>
            ))
        ) : (
        <option disabled>
            {getAllRouteQuery?.isLoading ? 'loading....' : getAllRouteQuery?.error ? 'error': ''}
        </option>
    )
   
    return (
        <FormikProvider value={formik}>
            <form onSubmit={formik.handleSubmit}>
                <FormWrapper>
                            <Field 
                                name='gradeLevel'
                                type='text'
                                as={Input}
                                label='Grade Level'
                                placeholder='Select'
                            />
                            <Field 
                                name='score'
                                type='number'
                                as={Input}
                                label='Score'
                                placeholder='Score'
                            />   
                            <Field 
                                name='routeId'
                                type='number'
                                as={Select}
                                label='Route Name'
                                options= {RouteTypeOption}
                                placeholder='Select'
                            />            
                        </FormWrapper>
                    <ButtonWrapper>
                    <ButtonContainer>
                        <StyledButton text='Cancel' onClick={handleClose}/>
                        <StyledButton 
                            disabled={createScoreMutation.isLoading} 
                            text={createScoreMutation.isLoading ? "Submitting..." : "Submit"}
                            onClick={formik.handleSubmit} 
                            type="submit"
                        />
                    </ButtonContainer>
                </ButtonWrapper>
              
            </form>
        </FormikProvider>
    )
};


export default CreateScoreContent;

const FormWrapper = styled('div')`
    margin-inline: 3.5rem;
`

const ButtonWrapper = styled('div')`
    display: flex;
    justify-content: flex-end;
    margin-block: 2.5rem;
    padding-inline: 3.5rem;
`

const ButtonContainer = styled('div')`
    display: flex;
    gap: 2rem;
`

const StyledButton = styled(Button)`
    padding-block: 1rem;
    padding-inline: 2rem;
`

